function renderFacilities(data, container) {
    if (!data || !data.facilities || !container) return;

    const facilities = data.facilities;

    facilities.forEach((facility) => {

        const facilityLi = document.createElement("li");
        facilityLi.classList.add(
            "size-full",
            "facility-item",
            "md:justify-self-center",
            "group/training-card",
            "group-target",
            "flex",
            "mb-[1.5em]"
        );

        facilityLi.setAttribute("data-latitude", facility.latitude);

        facilityLi.setAttribute("data-longitude", facility.longitude);

        facilityLi.setAttribute("data-city", facility.cityName);
        facilityLi.setAttribute(
            "data-workouttypes",
            JSON.stringify(facility.workouts?.map((w) => w.id) ?? [])
        );

        facilityLi.setAttribute(
            "data-conveniences",
            JSON.stringify(facility.conveniences?.map((c) => c.id) ?? [])
        );

        const getCroppedImage = (url, width) => {
            if (!url) return "/fallback-image.jpg";
            return `${url}?width=${width}&mode=crop&quality=90`;
        };

        facilityLi.innerHTML = `
            <article class="w-full">
                <a class="w-full bg-inherit md:aspect-[1/1] flex flex-col gap-y-[var(--spacing-24)] 
                          md:border-t-0 border-t border-t-subtle md:p-0 pt-[var(--spacing-40)]" 
                          href="${facility.url}">
                    
                    <img class="h-full w-full px-1 rounded-high object-cover aspect-[1/1] 
                              md:group-hover/training-card:shadow-elevation-1 
                              md:group-hover/training-card:scale-105 transition-all md:block hidden"
                               src="${getCroppedImage(facility.image, 800)}"
                         srcset="
                ${getCroppedImage(facility.image, 300)} 300w,
                ${getCroppedImage(facility.image, 600)} 600w,
                ${getCroppedImage(facility.image, 800)} 800w,
                ${getCroppedImage(facility.image, 1200)} 1200w"
             sizes="(max-width: 400px) 300px,
                    (max-width: 768px) 600px,
                    (max-width: 1024px) 800px,
                    1200px"
             alt="${facility.facilityName}" />
                    
                    <div class="flex flex-col gap-y-[var(--spacing-8)]">
                        <h2 class="text-heading-2-md md:text-underline-container w-fit">${facility.facilityName}</h2>
                        <address class="text-text-soft text-body-s flex flex-col gap-y-[var(--spacing-4)] leading-[1.25]">
                            ${facility.facilityType ? `<p>${facility.facilityType}</p>` : ""}
                            <p>${facility.address}</p>
                        </address>
                    </div>
                </a>
            </article>
        `;

        container.appendChild(facilityLi);
    });

    if (typeof applyFilters === "function") {
        applyFilters(true);
    }

    if (window.lazySizes) {
        lazySizes.loader.unveil(container.querySelectorAll("img.lazy"));
    }

    resetList = false;
}
